import { CALL_API } from '../middleware/api';

// ACTIONS

export const CONNECTION_FETCH_REQUEST = 'connection/CONNECTION_FETCH_REQUEST';
export const CONNECTION_FETCH_SUCCESS = 'connection/CONNECTION_FETCH_SUCCESS';
export const CONNECTION_FETCH_ERROR = 'connection/CONNECTION_FETCH_ERROR';

// REDUCER
export default function reducer(
  state = {
    entities: null,
    result: [],
    current: null,
    fetching: false,
    fetched: false,
    error: null,
  },
  action
) {
  switch (action.type) {
    case CONNECTION_FETCH_REQUEST:
      return {
        ...state,
        fetching: true,
      };

    case CONNECTION_FETCH_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        current: action.payload,
      };

    case CONNECTION_FETCH_ERROR:
      return {
        ...state,
        fetching: false,
        error: action.payload,
      };
    default:
      return state;
  }
}

// Operations

export function fetchConnections(id) {
  return {
    [CALL_API]: {
      types: [
        CONNECTION_FETCH_REQUEST,
        CONNECTION_FETCH_SUCCESS,
        CONNECTION_FETCH_ERROR,
      ],
      promise: (httpClient) => httpClient.get(`/master/${id}/connection/list`),
    },
  };
}
